import {TURN, ALIGN} from './env'
import {flipSide} from './navigation'
import {Transition} from './transition'
import {LookaheadAlign} from './lookaheadAlign'

export function convertTransitionsToLookaheadAlign(
  transitions: Transition[]
): LookaheadAlign[] {
  if (transitions.length < 2) throw Error('path is too small')
  const lastTransition = transitions[transitions.length - 1]
  const transitionsExtended = [
    ...transitions,
    new Transition({
      from: flipSide(lastTransition.to),
      to: lastTransition.to,
      turn: TURN.CENTER,
      locks: []
    })
  ]
  const result: LookaheadAlign[] = []
  for (let i = 0; i < transitions.length; i++) {
    let nextTurn: LookaheadAlign | null = null
    for (let j = i + 1; !nextTurn && j < transitionsExtended.length; j++) {
      const futureTransition = transitionsExtended[j]
      if (futureTransition.turn !== TURN.CENTER)
        nextTurn = new LookaheadAlign({
          turn: futureTransition.turn,
          alignSide: futureTransition.to,
          distance: j - i
        })
    }
    if (!nextTurn)
      nextTurn = new LookaheadAlign({
        turn: TURN.STOP,
        alignSide: ALIGN.CENTER,
        distance: transitions.length - i
      })
    result.push(nextTurn)
  }
  return result
}
